import { downloadInformeCartera } from "./saga";

const actions = {
    DOWNLOAD_FACTURAS_REQUEST: 'DOWNLOAD_FACTURAS_REQUEST',
    DOWNLOAD_FACTURAS_SUCCESS: 'DOWNLOAD_FACTURAS_SUCCESS',
    RESET_DOWNLOAD_FACTURAS: 'RESET_DOWNLOAD_FACTURAS',
    
    DOWNLOAD_INFORME_VENTAS_REQUEST: 'DOWNLOAD_INFORME_VENTAS_REQUEST',
    DOWNLOAD_INFORME_VENTAS_SUCCESS: 'DOWNLOAD_INFORME_VENTAS_SUCCESS',

    DOWNLOAD_INFORME_CARTERA_REQUEST: 'DOWNLOAD_INFORME_CARTERA_REQUEST',
    DOWNLOAD_INFORME_CARTERA_SUCCESS: 'DOWNLOAD_INFORME_CARTERA_SUCCESS',

    DOWNLOAD_REMISIONES_REQUEST: 'DOWNLOAD_REMISIONES_REQUEST',
    DOWNLOAD_REMISIONES_SUCCESS: 'DOWNLOAD_REMISIONES_SUCCESS',
    
    DOWNLOAD_CAJA_REQUEST: 'DOWNLOAD_CAJA_REQUEST',
    
    DOWNLOAD_INFORME_COMPRAS_REQUEST: 'DOWNLOAD_INFORME_COMPRAS_REQUEST',
    DOWNLOAD_INFORME_COMPRAS_SUCCESS: 'DOWNLOAD_INFORME_COMPRAS_SUCCESS',

    INGRESOS_EFECTIVO: 'INGRESOS_EFECTIVO',
    INGRESOS_DAVIVIENDA: 'INGRESOS_DAVIVIENDA',
    INGRESOS_BANCOLOMBIA: 'INGRESOS_BANCOLOMBIA',
    INGRESOS_CAJA_CODICE: 'INGRESOS_CAJA_CODICE',
    EGRESOS_EFECTIVO: 'EGRESOS_EFECTIVO',
    EGRESOS_DAVIVIENDA: 'EGRESOS_DAVIVIENDA',
    EGRESOS_BANCOLOMBIA: 'EGRESOS_BANCOLOMBIA',
    EGRESOS_CAJA_CODICE: 'EGRESOS_CAJA_CODICE',
    EGRESOS_COMPRAS: 'EGRESOS_COMPRAS',
    
    INGRESOS_EFECTIVO_TUS_CUPOS: 'INGRESOS_EFECTIVO_TUS_CUPOS',
    INGRESOS_CAJA_TUS_CUPOS: 'INGRESOS_CAJA_TUS_CUPOS',
    EGRESOS_EFECTIVO_TUS_CUPOS: 'EGRESOS_EFECTIVO_TUS_CUPOS',
    EGRESOS_CAJA_TUS_CUPOS: 'EGRESOS_CAJA_TUS_CUPOS',
    
    downloadFacturas: data => ({
        type: actions.DOWNLOAD_FACTURAS_REQUEST,
        payload: data
    }),
    downloadInformeVentas: data => ({
        type: actions.DOWNLOAD_INFORME_VENTAS_REQUEST,
        payload: data
    }),
    downloadInformeCartera: data => ({
        type: actions.DOWNLOAD_INFORME_CARTERA_REQUEST,
        payload: data
    }),
    downloadRemisiones: data => ({
        type: actions.DOWNLOAD_REMISIONES_REQUEST,
        payload: data
    }),
    downloadInformeCompras: data => ({
        type: actions.DOWNLOAD_INFORME_COMPRAS_REQUEST,
        payload: data
    }),
    downloadCaja: (data, tipo) => ({
        type: actions.DOWNLOAD_CAJA_REQUEST,
        payload: data,
        tipo,
    }),
    resetDownloadFacturas: () => ({
        type: actions.RESET_DOWNLOAD_FACTURAS,
    }),
};
export default actions;